import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { DriveContact } from '@/models/drive.ts'
import ContactCard from '@/components/ContactCard.tsx'
import { useTrackStat } from '@/contexts/statsScopeContext.tsx'

interface ContactFooterProps {
  contact: DriveContact | null
  className?: string
}

export default function ContactFooter({ contact, className = '' }: ContactFooterProps) {
  // The footer sits at the very bottom, so "shown" means scrolled into view —
  // not mounted. Reported once per visit.
  const { ref, inView } = useInView({ triggerOnce: true })
  const track = useTrackStat()

  useEffect(() => {
    if (inView) {
      track('contact_view')
    }
  }, [inView])

  if (!contact) return null

  const hasContent = contact.company || contact.first_name || contact.last_name
    || contact.email || contact.phone || contact.website
    || contact.instagram || contact.facebook || contact.twitter
    || contact.tiktok || contact.youtube || contact.pinterest
    || contact.google || contact.image

  if (!hasContent) return null

  return (
    <footer ref={ref} className={`pt-20 pb-12 px-4 bg-neutral ${className}`}>
      <div className='container mx-auto'>
        <ContactCard contact={contact} />
      </div>
    </footer>
  )
}
